let fallbackKey;
/**
 * Use this if you do not have the Mobx store available in your JavaScript asset.
 * E. g. the `banner.js` does not rely on the mobx store and should access the
 * localized options via `window.realCookieBanner` directly.
 */ function getOptionsFromWindow() {
    const windowObject = window[process.env.slug.replace(/-([a-z])/g, (g)=>g[1].toUpperCase())];
    if (!windowObject) {
        if (fallbackKey) {
            return window[fallbackKey];
        }
        // window.realCookieBanner is not defined and probably overridden. But `anonymous_localize_script`
        // will set a random id and return the object via `window[randomId]`. We need to search it
        for(const key in window){
            const value = window[key];
            if ((value == null ? void 0 : value.textDomain) === process.env.slug) {
                fallbackKey = key;
                return value;
            }
        }
    }
    return windowObject;
}
export { getOptionsFromWindow };
